import RcSwitch from 'rc-switch';
import styles from './styles.less';
import classNames from 'classnames';
import renderNothing from 'react-recompose/renderNothing';
import Select from '@graphistry/viz/src/components/tethered-select';
import {
    Col,
    Row,
    Container,
    Popover,
    ListGroup,
    ListGroupItem,
    Button,
    Tooltip,
    OverlayTrigger
} from 'react-bootstrap';

let ExpressionEditor = renderNothing();

if (process.env.__CLIENT__) {
    ExpressionEditor = require('./editor').Editor;
}

function stopPropagation(e) {
    e && e.stopPropagation();
}

const expressionTooltip = <Tooltip id="expression-tooltip">Expression</Tooltip>;

const expressionEnabledTooltip = <Tooltip id="expression-enabled-tooltip">Enabled</Tooltip>;

const deleteExpressionTooltip = <Tooltip id="delete-expression-tooltip">Delete Expression</Tooltip>;

export function HistogramsList({ style, children, ...props }) {
    return (
        <div style={style}>
            <ExpressionTemplates {...props} />
            <ListGroup>
                {children.map(child => (
                    <ListGroupItem key={child.key} style={child.props.style}>
                        {child}
                    </ListGroupItem>
                ))}
            </ListGroup>
        </div>
    );
}

export function ExpressionsList({
    id,
    name,
    side,
    loading,
    style,
    children,
    templates,
    addExpression,
    ...props
}) {
    return (
        <Popover
            id={`${id}-popover`}
            onClick={stopPropagation}
            style={{ ...style, width: `400px`, minWidth: `400px` }}
            {...props}>
            <Popover.Title>{name}</Popover.Title>
            <Popover.Content>
                <Container fluid style={{ ...style, overflowY: 'auto', maxHeight: 300, padding: 0, flexWrap: 'nowrap', transform: '', position: 'static' }}>
                    {children}
                </Container>
            </Popover.Content>
            <div
                    style={{
                        padding: '9px 14px',
                        backgroundColor: '#f7f7f7',
                        borderBottomLeftRadius: '5px',
                        borderBottomRightRadius: '5px',
                        borderTop: '1px solid #ebebeb'
                    }}>
                    <ExpressionTemplates
                        loading={loading}
                        templates={templates}
                        addExpression={addExpression}
                        {...props}
                    />
            </div>
        </Popover>
    );
}

const dataTypeTextStyle = { fontStyle: 'italic', marginLeft: '5px' };
function TemplateOptionRenderer({ name, dataType, componentType, showDataTypes }) {
    return (
        <span>
            <span>{componentType}:</span>
            <label>{name}</label>
            {(showDataTypes && <span style={dataTypeTextStyle}>{dataType}</span>) || undefined}
        </span>
    );
}

export function ExpressionTemplates({
    name = 'Expressions',
    templates = [],
    placeholder = 'Select attribute for new entry...',
    loading = false,
    showDataTypes = true,
    addExpression,
    menuPlacement,
    className = styles['expression-select'],
    ...props
}) {
    templates = templates.slice(0);

    return (
        <Select
            {...props}
            isLoading={loading}
            className={className}
            placeholder={placeholder}
            id="add-expression-dropdown"
            title={`Add ${name.slice(0, -1)}`}
            inputProps={{
                autoComplete: "off",
                autoCorrect: "off",
                spellCheck: "off"
            }}
            menuPlacement={menuPlacement}
            optionRenderer={TemplateOptionRenderer}
            valueRenderer={TemplateOptionRenderer}
            onChange={({ value }) => addExpression(templates[value])}
            options={templates.map(({ name, dataType, identifier, componentType }, index) => ({
                value: index,
                label: `${identifier} (${dataType})`,
                name,
                dataType,
                identifier,
                componentType,
                showDataTypes
            }))}
        />
    );
}

export function ExpressionItem({
    id,
    input,
    level,
    readOnly,
    dataType,
    expressionType,
    name,
    enabled,
    attribute,
    templates,
    removeExpression,
    updateExpression,
    setExpressionEnabled,
    cancelUpdateExpression
}) {
    const isSystem = level === 'system';
    const colW = !isSystem ? 8 : 12;
    return (
        <Row className={styles['expression-row'] + ' ' + styles['expression-item']} style={{flexWrap: 'nowrap'}}>
            <Col xs={colW} md={colW} lg={colW} style={(!isSystem && { paddingRight: 0 }) || undefined}>
                <OverlayTrigger
                    placement="top"
                    trigger={!readOnly ? ['hover', 'focus'] : []}
                    overlay={expressionTooltip}>
                    <div
                        className={classNames({ [styles['read-only']]: readOnly })}
                        style={{ border: `1px solid #cccccc`, borderRadius: `3px`, minWidth: 250 }}>
                        <ExpressionEditor
                            name={`expression-${id}`}
                            width="100%"
                            height="100%"
                            readOnly={readOnly || isSystem}
                            value={input}
                            templates={templates}
                            onChange={input => cancelUpdateExpression({ id })}
                            onUpdate={input => updateExpression({ id, input, whileDisabled: true })}
                        />
                    </div>
                </OverlayTrigger>
            </Col>
            {!isSystem && (
                <Col
                    xs={4}
                    md={4}
                    lg={4}
                    className={styles['expression-row']}
                    style={{ padding: 0, transform: 'scale(0.9)' }}>
                    <Col xs={6} md={6} lg={6}>
                        <OverlayTrigger placement="top" overlay={expressionEnabledTooltip}>
                            <RcSwitch
                                defaultChecked={enabled}
                                checkedChildren={'On'}
                                unCheckedChildren={'Off'}
                                key={`expression-${id}-checked`}
                                onChange={newEnabled =>
                                    setExpressionEnabled({
                                        id,
                                        enabled: newEnabled
                                    })}
                            />
                        </OverlayTrigger>
                    </Col>
                    <Col xs={6} md={6} lg={6} style={{ paddingRight: 0 }}>
                        <OverlayTrigger placement="right" overlay={deleteExpressionTooltip}>
                            <Button
                                onClick={() => removeExpression({ id })}
                                className={classNames({ fa: true, 'fa-close': true })}
                            />
                        </OverlayTrigger>
                    </Col>
                </Col>
            )}
        </Row>
    );
}
